module.exports = __webpack_public_path__ + "05edc8918e5137f72fc0ad6e65da01c5.mp4";